<script setup>
import { DropdownMenuRoot } from 'radix-vue'

const props = defineProps({
  defaultOpen: { type: Boolean, default: undefined },
  open: { type: Boolean, default: undefined },
  dir: { type: String, default: undefined },
  modal: { type: Boolean, default: false },
})

const emits = defineEmits(['update:open'])
</script>

<template>
  <DropdownMenuRoot
    :default-open="props.defaultOpen"
    :open="props.open"
    :dir="props.dir"
    :modal="props.modal"
    @update:open="emits('update:open', $event)"
  >
    <slot />
  </DropdownMenuRoot>
</template>
